var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 329.928 329.928",
    style: {
      enableBackground: "new 0 0 329.928 329.928"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.604,278.4c5.95,5.224,12.092,10.614,18.41,16.202c0.043,0.038,0.087,0.077,0.131,0.115l21.018,18.155 c2.816,2.433,6.311,3.649,9.806,3.649s6.991-1.217,9.807-3.649l21.014-18.155c0.044-0.038,0.087-0.076,0.13-0.114 c41.607-36.796,72.802-64.966,95.371-92.44c26.36-32.088,38.638-61.101,38.638-91.305c0-54.646-42.805-97.451-97.449-97.451 c-24.56,0-48.827,9.248-67.511,25.279c-18.689-16.032-42.956-25.279-67.517-25.279C42.806,13.406,0,56.212,0,110.857 C0,176.912,45.99,217.286,115.604,278.4z M104.964,134.965h39.999V94.964h40.001v40.001h40v40h-40v39.999h-40.001v-39.999h-39.999 V134.965z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.b57b238b2ca9a55a3ba3dc4e642aa3e6.svg";
export { ForwardRef as ReactComponent };